import { DateTimePicker, useCreateEventContext } from '../';
import { combineDateTime } from '../../utils';
import { isAfter } from 'date-fns';
import cx from 'classnames';
import { Button, DeleteFontIcon } from 'react-md';

const DateTimeRangePicker = ({
  id = 'range-picker',
  startDate,
  onFromDateChange,
  onFromTimeChange,
  onToDateChange,
  onToTimeChange,
  fromDate,
  fromTime,
  toDate,
  toTime,
  fromDateDisabled,
  fromTimeDisabled,
  toDateDisabled,
  toTimeDisabled,
  disabled,
  restrictedFrom,
  restrictedTo,
  multiline,
  errorOverride,
  onClearFrom,
  onClearTo,
  showClearFrom,
  showClearTo
}) => {
  const {
    timezone
  } = useCreateEventContext();

  const errorChecker = () => {
    if (fromDate && fromTime && toDate && toTime) {
      if (errorOverride) {
        return errorOverride;

      } else if (isAfter(combineDateTime(fromDate, fromTime), combineDateTime(toDate, toTime))) {
        return 'End time must be after start time';
      }
    }

    return null;
  };

  return (
    <div className={cx('date-time-range-picker-container', { 'date-time-range-picker-disabled': disabled })}>
      <div className={cx('date-time-range-picker', { multiline })}>
        <div className="date-time-picker-with-clear">
          <DateTimePicker
            id={`${id}-from`}
            selectedDate={fromDate}
            selectedTime={fromTime}
            onDateChange={onFromDateChange}
            onTimeChange={onFromTimeChange}
            startDate={startDate}
            dateDisabled={disabled || fromDateDisabled}
            timeDisabled={disabled || fromTimeDisabled}
            restrictToDateTime={restrictedFrom}
            label={multiline && 'From'}
            timezone={timezone}
          />
          {onClearFrom && (
            <Button
              buttonType="icon"
              className={cx('clear-date-time-button', { 'clear-button-visible': showClearFrom })}
              onClick={onClearFrom}
              disabled={disabled || !showClearFrom}
            >
              <DeleteFontIcon />
            </Button>
          )}
        </div>
        {!multiline &&
          <div className="range-separator">
            &mdash;
          </div>
        }
        <div className="date-time-picker-with-clear">
          <DateTimePicker
            id={`${id}-to`}
            selectedDate={toDate}
            selectedTime={toTime}
            onDateChange={onToDateChange}
            onTimeChange={onToTimeChange}
            startDate={combineDateTime(fromDate, fromTime)}
            dateDisabled={disabled || toDateDisabled}
            timeDisabled={disabled || toTimeDisabled}
            restrictToDateTime={restrictedTo}
            label={multiline && 'To'}
            timezone={timezone}
          />
          {onClearTo && (
            <Button
              buttonType="icon"
              className={cx('clear-date-time-button', { 'clear-button-visible': showClearTo })}
              onClick={onClearTo}
              disabled={disabled || !showClearTo}
            >
              <DeleteFontIcon />
            </Button>
          )}
        </div>
      </div>
      {errorChecker() &&
        <div className="date-time-range-picker-error">
          {errorChecker()}
        </div>
      }
    </div>
  );
};

export default DateTimeRangePicker;
